module.exports = __webpack_public_path__ + "media/images/home/ic_duplicate-8373023d9b22985c23deebe72c10b762.svg";